import { Controller } from "@hotwired/stimulus"

const ACTIVE_CLASSES = ["border-indigo-600", "text-indigo-600"]
const INACTIVE_CLASSES = ["border-transparent", "text-gray-500", "hover:text-gray-700", "hover:border-gray-300"]

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    if (this.tabTargets.length > 0) {
      this.activate(this.tabTargets[0].dataset.tab)
    }
  }

  select(event) {
    event.preventDefault()
    const tab = event.currentTarget.dataset.tab
    this.activate(tab)
  }

  activate(tab) {
    this.tabTargets.forEach((t) => {
      const isActive = t.dataset.tab === tab
      t.classList.toggle("border-b-2", true)
      ACTIVE_CLASSES.forEach((c) => t.classList.toggle(c, isActive))
      INACTIVE_CLASSES.forEach((c) => t.classList.toggle(c, !isActive))
    })
    this.panelTargets.forEach((p) => {
      p.classList.toggle("hidden", p.dataset.tab !== tab)
    })
  }
}
